import { NavLink, useLocation } from 'react-router-dom';
import Menu from "../../json/menu_panel.json";
import IconRenderer from './IconRenderer';
import { FaCamera } from 'react-icons/fa';

export default function NavbarBottom() {
    const paths = useLocation().pathname;
    const url = paths;

    return (
        <>
            <div className="md:hidden fixed bottom-0 w-full flex items-center justify-center z-50 pb-[env(safe-area-inset-bottom,0px)]">
                <div className="w-full max-w-md mx-auto">
                    {/* Overlay di atas kamera — sudut transparan biar kamera full ke pojok */}
                    <div className="bg-white/90 backdrop-blur-xl shadow-[0_-4px_30px_rgba(0,0,0,0.12)] border-t border-gray-200/40 rounded-t-3xl px-3 py-3">
                        <div className="flex items-center justify-around relative">
                            {Menu.map((item, index) => {
                                const isActive = item.link === url;
                                const isAbsensi = item.link === '/absensi';

                                if (isAbsensi) {
                                    // Special floating button for Absensi
                                    return (
                                        <NavLink
                                            key={index}
                                            to={item.link}
                                            className="flex flex-col items-center justify-center flex-1 relative -mt-8"
                                        >
                                            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-zafu-green to-zafu-green-soft flex items-center justify-center shadow-[0_8px_24px_rgba(27,60,51,0.45)] ring-4 ring-white transition-transform duration-300 hover:scale-110 active:scale-95">
                                                <FaCamera className="text-white text-xl" />
                                            </div>
                                        </NavLink>
                                    );
                                }

                                return (
                                    <NavLink
                                        key={index}
                                        to={item.link}
                                        className="flex flex-col items-center justify-center flex-1 relative transition-all duration-300 group"
                                    >
                                        {/* Active Indicator Dot */}
                                        {/* {isActive && (
                                            <div className="absolute -top-1 w-1 h-1 bg-[#1B3C33] rounded-full"></div>
                                        )} */}

                                        {/* Icon Container with Background when Active */}
                                        <div className={`relative transition-all duration-300 ${isActive
                                            ? 'bg-[#1B3C33]/10 rounded-2xl p-2 scale-110'
                                            : 'p-2 scale-100'
                                            }`}>
                                            <div className={`text-xl flex justify-center transition-colors duration-300 ${isActive ? 'text-[#1B3C33]' : 'text-gray-400 group-hover:text-gray-600'
                                                }`}>
                                                <IconRenderer iconStr={item.icon} />
                                            </div>
                                        </div>

                                        {/* Label */}
                                        <span className={`text-[10px] font-medium mt-1 transition-all duration-300 ${isActive
                                            ? 'text-[#1B3C33] opacity-100'
                                            : 'text-gray-500'
                                            }`}>
                                            {item.name}
                                        </span>
                                    </NavLink>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
